import React from "react";

type Props = {
    agree: boolean;
    agree_error?: string;
    setValue: (name: string, value: string | boolean) => void;
};

export const Agree = ({ agree, agree_error, setValue }: Props) => {
    return (
        <div className={`form-flex form-agree${agree_error ? ' form-input-error' : ''}`}>
            <div className="agree-row">
                <label>
                    <input type="checkbox" name="agree" value="1" required
                           checked={agree}
                           onChange={(e) => setValue('agree', e.target.checked)}
                    />
                    <a href="/privacy/" target="_blank" className="re-text">個人情報の取り扱い</a>に同意する
                </label>
            </div>

            {agree_error && <div className="form-error-message">{agree_error}</div>}
        </div>
    );
};
